var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      style: { zIndex: _vm.options.zIndex },
      attrs: { "max-width": _vm.options.width },
      on: {
        keydown: [
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
            )
              return null
            return _vm.cancel.apply(null, arguments)
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.agree.apply(null, arguments)
          },
        ],
      },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "confirm-card" },
        [
          _c(
            "v-toolbar",
            {
              attrs: {
                color: _vm.options.color,
                dark: "",
                dense: "",
                flat: "",
              },
            },
            [
              _c(
                "v-toolbar-title",
                { staticClass: "white--text center-title" },
                [
                  _vm._v(_vm._s(_vm.title) + "\n        "),
                  _c(
                    "v-fab-transition",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            dark: "",
                            color: "white",
                            fab: "",
                            icon: "",
                            small: "",
                            absolute: "",
                            right: "",
                            top: "",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.cancel.apply(null, arguments)
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("fal fa-times-circle")])],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-card-text", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !!_vm.message,
                expression: "!!message",
              },
              {
                name: "dompurify-html",
                rawName: "v-dompurify-html",
                value: _vm.message,
                expression: "message",
              },
            ],
            staticClass: "center-question",
          }),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "pt-0 center-actions" },
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "action-btns",
                  attrs: { color: "#6D787E", outlined: "", large: "" },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.cancel.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.noText))]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "action-btns",
                  attrs: {
                    dark: "",
                    large: "",
                    depressed: "",
                    color: _vm.options.color,
                  },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.agree.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.title))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }